// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ct3S6","placeholdersHeader":"styles_placeholdersHeader__1KOUk","editorStyle":"styles_editorStyle__10dzB","placeholdersBox":"styles_placeholdersBox__3mLTf"};